import algoliasearch from 'algoliasearch/lite';

const { ALGOLIA_APPLICATION_ID, ALGOLIA_SEARCH_ONLY_API_KEY } = window.cssh.env;

let searchClient = null;

try {
  searchClient = algoliasearch(ALGOLIA_APPLICATION_ID, ALGOLIA_SEARCH_ONLY_API_KEY);
} catch (e) {
  console.error(e);
}

export default searchClient;
